export default "__VITE_ASSET__CwYQFUjq__"